/**
 * Background art for the Profile and Change password popups.
 *
 * `community.banner` is the old community-setup image, which no membership can
 * set any more, so it is always the platform's stock photo. The image creators
 * actually upload is the membership card's: Brand → Logo & Banner
 * (`dashboard_banner`), then the Create-Membership image (`membership_banner`).
 * flexiapi fills `dashboard_banner` with its own stock photo when nothing was
 * uploaded, so that one is recognised and skipped.
 */
const STOCK_DASHBOARD_BANNER = "photo-1529156069898-49953e39b3ac";

export default function profileBanner(community) {
  if (!community) return undefined;
  const dash = community.dashboard_banner || "";
  if (dash && !dash.includes(STOCK_DASHBOARD_BANNER)) return dash;
  return community.membership_banner || community.banner;
}
